/**
 * Some single-resource GET/POST endpoints under the Investors/Investments
 * tag wrap the resource in Laravel's default API Resource `{ data: {...} }`
 * envelope, even though the docs describe these specific responses as bare
 * objects. This is the same underlying Laravel convention that showed up as
 * `{ data: [...], links, meta }` on the paginated list endpoints (see
 * parseLaravelPaginator.js) — this backend appears to use Laravel API
 * Resources with default wrapping everywhere, and the docs just don't
 * reflect that consistently.
 *
 * Confirmed live: GET /admin/investors/{uuid} came back with every profile
 * field reading as undefined (status badge fell back to "UNKNOWN", phone/
 * last-login/joined all blank) — the actual payload was `{ data: {...} }`,
 * not the bare object the docs show, so normalizeAdminInvestorView() was
 * being handed the wrapper instead of the investor.
 *
 * Tolerates both shapes: if `response.data` is a non-array object, unwrap
 * it; otherwise assume `response` itself is already the resource. Never
 * touches a paginator's `data` array — that's a list, not a wrapped single
 * resource, and is handled separately by parseLaravelPaginator.
 */
export function unwrapMaybeWrapped(response) {
  if (response && response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return response.data;
  }
  return response;
}

export default unwrapMaybeWrapped;
